<script setup>
import { computed } from 'vue'
import { audiences } from '../audiences'

// Cards linking the audience landings: all of them on the home page, the other ones at the end of each landing.
const props = defineProps({
  current: { type: String, default: '' },
  title: { type: String, default: 'С кем играть?' },
  titleId: { type: String, default: 'audiences-title' },
})

const items = computed(() => audiences.filter(item => item.name !== props.current))
</script>

<template>
  <section class="landing-audiences" :class="{ 'is-trio': items.length > 2 }" :aria-labelledby="titleId">
    <h2 :id="titleId">{{ title }}</h2>
    <div>
      <RouterLink v-for="item in items" :key="item.name" class="audience-card" :class="`audience-card-${item.name}`" :to="`/${item.name}`">
        <img :src="item.image" :alt="item.alt" loading="lazy" />
        <span><small>{{ item.label }}</small><strong>{{ item.title }}</strong><em>{{ item.text }}</em></span>
      </RouterLink>
    </div>
  </section>
</template>
